


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import TodayInfo from './components/info.vue'
import TodayTask from './components/task.vue'
import TodayTaskEmpty from './components/taskempty.vue'
import DayPlan from '@/model/plan/dayPlan'
import MyDayPlan from '@/model/plan/myDayPlan'
import Mood from '@/model/plan/mood'

import YKDClass from '@/model/class/class'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component({
  components: {
    TodayInfo,
    TodayTask,
    TodayTaskEmpty,
  },
})
export default class StudyPlanToday extends Vue {
  @ModuleStudyPlan.State((state) => state.myDayPlan)
  private myDayPlan!: MyDayPlan
  @ModuleStudyPlan.State((state) => state.myClass)
  private myClass!: YKDClass
}
